import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
//import { useParams } from 'react-router';
import './SiteForm.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import { useParams } from 'react-router';

type IaFormParams = {
  id:string, 
  dummy:string
}

const IaForm: React.FC = () => {

  const {id, dummy} = useParams<IaFormParams>();

 const name:string = "Site Form";

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle>{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        id : {id}

      </IonContent>
    </IonPage>
  );
};

export default IaForm;
